import { action } from 'satcheljs/lib/legacy';
import { ComposeViewState } from 'owa-mail-compose-store';

export default action('setShowSendDiscardAsIcon')(function setShowSendDiscardAsIcon(
    viewState: ComposeViewState,
    showSendDiscardAsIcon: boolean
) {
    viewState.showSendDiscardAsIcon = showSendDiscardAsIcon;
});
